import Vue from 'vue';
import Router from 'vue-router';
import Login from './views/frame/Login';
import Index from './views/frame/Index';
import Main from './views/frame/Main';
import AccountManager from './views/security/AccountManager';
import PhysicGraph from './views/topo/TopoMonitor/PhysicGraph';
import LogicalGraph from './views/topo/TopoMonitor/LogicalGraph';
import DeviceManage from './views/topo/ResourceManage/DeviceManage';
import NeManage from './views/topo/ResourceManage/NeManage';
import MML from './views/mmlconfig/MML';
import MMLBackup from './views/mmlconfig/MMLBackup';
import MMLGLOBAL from './views/mmlconfig/MMLGLOBAL';
import CurrentAlarm from './views/alarm/CurrentAlarmPage';
import HistoryAlarm from './views/alarm/HistoryAlarmPage';
import SystemManager from './views/system/MissionManager';
import EventLog from './views/alarm/EventLogPage';
import BlockingRule from './views/alarm/BlockingRulePage';
import FilterRule from './views/alarm/FilterRulePage';
import BusyTimeIndicatorThresholdPage from './views/alarm/BusyTimeIndicatorThresholdPage';
import IdelTimeIndicatorThresholdPage from './views/alarm/IdelTimeIndicatorThresholdPage';
import CallBack from './views/alarm/CallBackPage';
import WarnFilter from './views/alarm/WarnFilterPage';
import CallBackLog from './views/alarm/CallBackLogPage';
import AlarmNotice from './views/alarm/AlarmNoticePage';
import MCSUserMain from './views/subscriber/mcsSubscriber/user/UserMainPage';
import MCSGroupMain from './views/subscriber/mcsSubscriber/group/GroupMainPage';
import PDNProfileMain from './views/subscriber/epcSubscriber/pdn/PDNMainPage';
import DNNProfileMain from './views/subscriber/udmSubscriber/dnn/DNNMainPage';
import SnssaiMainPage from './views/subscriber/udmSubscriber/snssai/SnssaiMainPage';
import AmDataMainPage from './views/subscriber/udmSubscriber/amdata/AmDataMainPage';
import PlmnMainPage from './views/subscriber/udmSubscriber/plmn/PlmnMainPage';
import UsersubMainPage from './views/subscriber/udmSubscriber/usersub/UsersubMainPage';
import SupiMainPage from './views/subscriber/udmSubscriber/supi/SupiMainPage';
import SpecialDataMainPage from './views/subscriber/udmSubscriber/specialdata/SpecialDataMainPage';
import PviMainPage from './views/subscriber/vonrSubscriber/pvi/PviMainPage';
import PuiMainPage from './views/subscriber/vonrSubscriber/pui/PuiMainPage';
import ProfileMain from './views/subscriber/epcSubscriber/profile/ProfileMainPage';
import LTEUserMain from './views/subscriber/epcSubscriber/user/UserMainPage';

import MCSUserMainMicro from './views/subscriberMicro/mcsSubscriber/user/UserMainPage';
import MCSGroupMainMicro from './views/subscriberMicro/mcsSubscriber/group/GroupMainPage';
import MCSAreaMainMicro from './views/subscriberMicro/mcsSubscriber/area/AreaMainPage';
import MCSBatchMainMicro from './views/subscriberMicro/mcsSubscriber/batch/BatchManagement';

import DataManager from './views/system/DataManager';
import ConfigExAndImport from './views/system/ConfigExAndImport';
import BatchInitializeNeCfg from './views/system/BatchInitializeNeCfg';
import CheckParamList from './views/system/CheckParamList';
import AdapterPkg from './views/system/AdapterPkg';
import AddressBook from './views/system/AddressBook';
import HistoryMail from './views/system/HistoryMail';
import MailServer from './views/system/MailServer';
import Personal from './views/system/Personal';
import MapConfig from './views/system/MapConfig';
import AlarmRedirect from './views/alarm/AlarmRedirectPage';
import ConfigBackupAndRecover from './views/system/ConfigBackupAndRecover';
import imsUserManagement from './views/subscriber/imsSubscriber/user/imsUserManagement';
import GroupManagement from './views/subscriber/imsSubscriber/group/GroupManagement';
import VersionUpdate from './views/software/VersionUpdate';
import VersionBack from './views/software/VersionBack';
import VersionLib from './views/software/VersionLib';
import TscIpAutoDistributePage from './views/software/TscIpAutoDistributePage';
import VersionQuery from './views/software/VersionQuery';
import AppUpdate from './views/software/AppUpdate';

import PmNoRealTaskManagement from './views/pm/pproject/PmTaskManagementForP';
import PmNoRealDataQuery from './views/pm/pproject/PmDataQueryForP';
import PmReportManagement from './views/pm/pproject/PmReportManagementForP';
import PmCounterManagement from './views/pm/pproject/PmCounterManagementForP';
import pmAlarmQuery from './views/pm/pproject/PmAlarmManagementForP';

import pmTaskManagementForGnb from './views/pm/gnb/PmTaskManagementForGnb';
import pmCounterManagementForGnb from './views/pm/gnb/PmCounterManagementForGnb';
import pmDataQueryForGnb from './views/pm/gnb/PmDataQueryForGnb';
import pmReportGnbTemplate from './views/pm/gnb/PmReportGnbTemplate';
import pmReportTaskGnb from './views/pm/gnb/PmReportTaskGnb';
import pmReportGnbData from './views/pm/gnb/PmReportGnbData';

import indicatorManagementPage from './views/pm/4gproject/IndicatorManagementPage';
import MeasureCustom from './views/pm/4gproject/MeasureCustom';
import kpiChartShowPage from './views/pm/4gproject/KpiChartShowPage';
import noRealQueryPage from './views/pm/4gproject/NoRealQueryPage';
import noRealTaskPage from './views/pm/4gproject/NoRealTaskPage';
import realTimeTaskPage from './views/pm/4gproject/RealTimeTaskPage';

import RoleManager from './views/security/RoleManager';
import StrategyManager from './views/security/StrategyManager';
import AccountMonitor from './views/security/AccountMonitor';
import CallFailCountStatistics from './views/ts/CallFailCountStatisticsPage';
import CallSetUpTimeStatistics from './views/ts/CallSetUpTimeStatisticsPage';
import CallCountStatistics from './views/ts/CallCountStatisticsPage';
import OnlineUserStatistics from './views/ts/OnlineUserStatisticsPage';
import OnlineTimeStatistics from './views/ts/OnlineTimeStatisticsPage';
import SignalTrack from './views/track/SignalTrackPage';
import UserTrack from './views/track/UserTrackPage';
import MonitTrack from './views/track/MonitTrackPage';
import ImportTrack from './views/track/ImportTrackPage';
import TrafficTask from './views/ts/TrafficTaskPage';
import DailyActivityStatisticsPage from './views/ts/DailyActivityStatisticsPage';
import RegisterCountByTypeStatisticsPage from './views/ts/RegisterCountByTypeStatisticsPage';
import DigitalCountByTypeStatisticsPage from './views/ts/DigitalCountByTypeStatisticsPage';
import LogManager from './views/security/LogManager';
import ImsiTemplateManagement from './views/subscriber/imsSubscriber/template/ImsTemplateManagement';
import ImsInfoManagement from './views/subscriber/imsSubscriber/staff/ImsInfoManagement';
import DataManagement from './views/subscriber/datamanage/DataManagement';
import Spectrum from './views/spectrum/SpectrumPage';
import UEList from './views/ue/UeListPage';
import UeShowMap from "./views/ue/UeShowMap";
import LicenseManager from './views/security/LicenseManager';
import RackGraph from './views/topo/TopoMonitor/RackGraph.vue';
import DeployedInstance from './views/deploymentManagement/deployedInstanManagement/DeployedInstance.vue';
import LteNeManagement from './components/software/NetElementList';
import ServerManagement from './views/deploymentManagement/serviceManagement/ServerManagement.vue';
import RunEnvironment from './views/deploymentManagement/runningEnvironment/RunEnvironment'
import FailObserve from './views/observe/FailObservePage';
import MonitObserve from './views/observe/MonitObservePage';
import ClientManager from './views/security/ClientManager';
import GroupManager from './views/security/GroupManager';
import ServiceProfile from './views/nsmf/ServiceProfilePage';
import SliceProfile from './views/nsmf/SliceProfilePage';
import NSI from './views/nsmf/NSIPage';
import NSSI from './views/nsmf/NSSIPage';
import AccountOperateCalc from './views/security/AccountOperateCalc';


import MonitorTask from './views/monitor/MonitorTask';
import MonitorSystemLog from './views/monitor/MonitorSystemLog';
import MonitorServiceProcessPage from './views/monitor/monitorServiceProcess/MonitorServiceProcessPage';
import RealtimeMonitor from './views/monitor/RealtimeMonitor';

import Threshold from './views/system/Threshold';
import AlarmPresent from './views/system/AlarmPresent';
import TopoConfig from './views/system/TopoConfig';

import MrMeasureTask from './views/mr/MrMeasureTask';
import SystemQuery from './views/system/SystemQuery';
import EMAP from './views/topo/TopoMonitor/EMAP.vue';

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

Vue.use(Router);

export default new Router({
  // mode: 'hash',
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'root',
      component: Login
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/index',
      name: 'index',
      component: Index,
      children: [
        {
          path: '/main',
          name: 'main',
          component: Main
        },
        /*{
          path: '/ueList',
          name: 'ueList',
          component: UEList
        },*/
        {
          path: '/spectrum',
          name: 'spectrum',
          component: Spectrum
        },
      ]
    },
    {
      path: '/mml',
      name: 'mml',
      component: Index,
      children: [
        {
          path: 'mmlConfig',
          name: 'mmlConfig',
          component: MML
        },
        {
          path: 'mmlBackup',
          name: 'mmlBackup',
          component: MMLBackup
        },
        {
          path: 'moGlobalParam',
          name: 'moGlobalParam',
          component: MMLGLOBAL
        }
      ]
    },
    {
      path:'/ue',
      name:'ue',
      component: Index,
      children: [
        {
          path: 'ueList',
          name: 'ueList',
          component: UEList
        },
        {
          path:'ueMap',
          name:'ueMap',
          component: UeShowMap
        }
      ]
    },
    {
      path: '/topo',
      name: 'topo',
      component: Index,
      children: [
        {
          path: 'physicGraph',
          name: 'physicGraph',
          component: PhysicGraph
        },
        {
          path: 'logicalGraph',
          name: 'logicalGraph',
          component: LogicalGraph
        },
        {
          path: 'deviceManage',
          name: 'deviceManage',
          component: DeviceManage
        },
        {
          path: 'neManage',
          name: 'neManage',
          component: NeManage
        },
        // {
        //   path: 'trunkManage',
        //   name: 'trunkManage',
        //   component: TrunkManage
        // },
        {
          path: 'rackGraph',
          name: 'rackGraph',
          component: RackGraph
        },
        {
          path: 'eMap',
          name: 'eMap',
          component: EMAP
        },
      ]
    },
    {
      path: '/micpoc',
      name: 'micpoc',
      component: Index,
      children: [
        {
          path: 'serverManagement',
          name: 'serverManagement',
          component: ServerManagement
        },
        // {
        //   path: 'deployedInstance',
        //   name: 'deployedInstance',
        //   component: DeployedInstance
        // },
        {
          path: 'environment',
          name: 'environment',
          component: RunEnvironment
        }
      ]
    },
    {
      path: '/service',
      name: 'service',
      component: Index,
      children: [
        {
          path: 'lteNeManagement',
          name: 'lteNeManagement',
          component: LteNeManagement
        },
        {
          path: 'deployedInstance',
          name: 'deployedInstance',
          component: DeployedInstance
        }
      ]
    },
    {
      path: '/alarm',
      name: 'alarm',
      component: Index,
      children: [
        {
          path: 'currentAlarm',
          name: 'currentAlarm',
          component: CurrentAlarm
        },
        {
          path: 'historyAlarm',
          name: 'historyAlarm',
          component: HistoryAlarm
        },
        {
          path: 'eventLog',
          name: 'eventLog',
          component: EventLog
        },
        {
          path: 'blockingRule',
          name: 'blockingRule',
          component: BlockingRule
        },
        {
          path: 'filterRule',
          name: 'filterRule',
          component: FilterRule
        },
        {
          path: 'busyTimeIndicatorThreshold',
          name: 'busyTimeIndicatorThreshold',
          component: BusyTimeIndicatorThresholdPage
        },
        {
          path: 'idelTimeIndicatorThreshold',
          name: 'idelTimeIndicatorThreshold',
          component: IdelTimeIndicatorThresholdPage
        },
		    {
          path: 'warnFilter',
          name: 'warnFilter',
          component: WarnFilter
        },
        {
          path: 'callBack',
          name: 'callBack',
          component: CallBack
        },
        {
          path: 'callBackLog',
          name: 'callBackLog',
          component: CallBackLog
        },
        {
          path: 'alarmNotice',
          name: 'alarmNotice',
          component: AlarmNotice
        },
        {
          path: 'alarmRedirect',
          name: 'alarmRedirect',
          component: AlarmRedirect
        }
      ]
    },
    {
      path: '/subscriber',
      name: 'subscriber',
      component: Index,
      children: [
        {
          path: 'lte/pdnProfile',
          name: 'pdnProfile',
          component: PDNProfileMain
        },
        {
          path: 'udm/dnnProfile',
          name: 'dnnProfile',
          component: DNNProfileMain
        },
        {
          path: 'udm/snssaiProfile',
          name: 'snssaiProfile',
          component: SnssaiMainPage
        },
        {
          path: 'udm/amdataProfile',
          name: 'amdataProfile',
          component: AmDataMainPage
        },
        {
          path: 'udm/plmnProfile',
          name: 'plmnProfile',
          component: PlmnMainPage
        },
        {
          path: 'udm/usersubProfile',
          name: 'usersubProfile',
          component: UsersubMainPage
        },
        {
          path: 'udm/supiProfile',
          name: 'supiProfile',
          component: SupiMainPage
        },
        {
          path: 'udm/specialdataProfile',
          name: 'specialdataProfil',
          component: SpecialDataMainPage
        },
        {
          path: 'vonr/pviProfile',
          name: 'pviProfile',
          component: PviMainPage
        },
        {
          path: 'vonr/puiProfile',
          name: 'puiProfile',
          component: PuiMainPage
        },
        {
          path: 'lte/profile',
          name: 'profile',
          component: ProfileMain
        },
        {
          path: 'lte/lteUser',
          name: 'lteUser',
          component: LTEUserMain
        },
        {
          path: 'mcs/mcsUser',
          name: 'mcsUser',
          component: MCSUserMain
        },
        {
          path: 'mcs/mcsGroup',
          name: 'mcsGroup',
          component: MCSGroupMain
        },
        {
          path: 'ims/imsUserManagement',
          name: 'imsUserManagement',
          component: imsUserManagement
        },
        {
          path: 'ims/groupManagement',
          name: 'groupManagement',
          component: GroupManagement
        },
        {
          path: 'ims/imsTemplateManagement',
          name: 'imsTemplateManagement',
          component: ImsiTemplateManagement
        },
        {
          path: 'ims/imsInfoManagement',
          name: 'imsInfoManagement',
          component: ImsInfoManagement
        },
        {
          path: 'dataManagement',
          name: 'dataManagement',
          component: DataManagement
        }
      ]
    },
    {
      path: '/subscriberMicro',
      name: 'subscriberMicro',
      component: Index,
      children: [
        {
          path: 'mcs/mcsUserMicro',
          name: 'mcsUser',
          component: MCSUserMainMicro
        },
        {
          path: 'mcs/mcsGroupMicro',
          name: 'mcsGroup',
          component: MCSGroupMainMicro
        },
        {
          path: 'mcs/mcsAreaMicro',
          name: 'mcsArea',
          component: MCSAreaMainMicro
        },
        {
          path: 'mcs/mcsBatchMicro',
          name: 'mcsBatch',
          component: MCSBatchMainMicro
        }
      ]
    },
    {
      path: '/ts',
      name: 'ts',
      component: Index,
      children: [
        {
          path: 'callFailCountStatistics',
          name: 'callFailCountStatistics',
          component: CallFailCountStatistics
        },
        {
          path: 'callSetUpTimeStatistics',
          name: 'callSetUpTimeStatistics',
          component: CallSetUpTimeStatistics
        },
        {
          path: 'callCountStatistics',
          name: 'callCountStatistics',
          component: CallCountStatistics
        },
        {
          path: 'onlineUserStatistics',
          name: 'onlineUserStatistics',
          component: OnlineUserStatistics
        },
        {
          path: 'onlineTimeStatistics',
          name: 'onlineTimeStatistics',
          component: OnlineTimeStatistics
        },
        {
          path: 'trafficTask',
          name: 'trafficTask',
          component: TrafficTask
        },
        {
          path: 'dailyActivityStatistics',
          name: 'dailyActivityStatistics',
          component: DailyActivityStatisticsPage
        },
        {
          path: 'registerCountByTypeStatistics',
          name: 'registerCountByTypeStatistics',
          component: RegisterCountByTypeStatisticsPage
        },
        {
          path: 'digitalCountByTypeStatistics',
          name: 'digitalCountByTypeStatistics',
          component: DigitalCountByTypeStatisticsPage
        }
      ]
    },
    {
      path: '/pm',
      name: 'pm',
      component: Index,
      children: [
        {
          path: 'pmNoRealTaskManagement',
          name: 'pmNoRealTaskManagement',
          component: PmNoRealTaskManagement
        },
        {
          path: 'pmNoRealDataQuery',
          name: 'pmNoRealDataQuery',
          component: PmNoRealDataQuery
        },

        {
          path: 'pmNoRealReport',
          name: 'pmNoRealReport',
          component: PmReportManagement
        },

        {
          path: 'pmCounterAndThresholdManagement',
          name: 'pmCounterAndThresholdManagement',
          component: PmCounterManagement
        },
        {
          path: 'pmAlarmManagement',
          name: 'pmAlarmManagement',
          component: pmAlarmQuery
        },
        {
          path: 'pmTaskManagementForGnb',
          name: 'pmTaskManagementForGnb',
          component: pmTaskManagementForGnb
        },
        {
          path: 'pmDataQueryForGnb',
          name: 'pmDataQueryForGnb',
          component: pmDataQueryForGnb
        },
        {
          path: 'pmReportGnbTemplate',
          name: 'pmReportGnbTemplate',
          component: pmReportGnbTemplate
        },
        {
          path: 'pmReportTaskGnb',
          name: 'pmReportTaskGnb',
          component: pmReportTaskGnb
        },
        {
          path: 'pmReportGnbData',
          name: 'pmReportGnbData',
          component: pmReportGnbData
        },
        {
          path: 'pmCounterManagementForGnb',
          name: 'pmCounterManagementForGnb',
          component: pmCounterManagementForGnb
        },
        {
          path: 'indicatorManagementPage',
          name: 'indicatorManagementPage',
          component: indicatorManagementPage
        },
        {
          path: 'measureCustom',
          name: 'measureCustom',
          component: MeasureCustom
        },
        {
          path: 'kpiChartShowPage',
          name: 'kpiChartShowPage',
          component: kpiChartShowPage
        },
        {
          path: 'noRealQueryPage',
          name: 'noRealQueryPage',
          component: noRealQueryPage
        },
        {
          path: 'noRealTaskPage',
          name: 'noRealTaskPage',
          component: noRealTaskPage
        },
        {
          path: 'realTimeTask',
          name: 'realTimeTask',
          component: realTimeTaskPage
        }
      ]
    },
    {
      path: '/track',
      name: 'track',
      component: Index,
      children: [
        {
          path: 'signalTrack',
          name: 'signalTrack',
          component: SignalTrack
        },
        {
          path: 'userTrack',
          name: 'userTrack',
          component: UserTrack
        },
        {
          path: 'monitTrack',
          name: 'monitTrack',
          component: MonitTrack
        },
        {
          path: 'importTrack',
          name: 'importTrack',
          component: ImportTrack
        }
      ]
    },
    {
      path: '/observe',
      name: 'observe',
      component: Index,
      children: [
        {
          path: 'failObserve',
          name: 'failObserve',
          component: FailObserve
        },
        {
          path: 'monitObserve',
          name: 'monitObserve',
          component: MonitObserve
        }
      ]
    },
    {
      path: '/nsmf',
      name: 'nsmf',
      component: Index,
      children: [
        {
          path: 'serviceProfile',
          name: 'serviceProfile',
          component: ServiceProfile
        },
        {
          path: 'nsi',
          name: 'nsi',
          component: NSI
        },
        {
          path: 'sliceProfile',
          name: 'sliceProfile',
          component: SliceProfile
        },
        {
          path: 'nssi',
          name: 'nssi',
          component: NSSI
        }
      ]
    },
    {
      path: '/software',
      name: 'software',
      component: Index,
      children: [
        {
          path: 'versionLib',
          name: 'versionLib',
          component: VersionLib
        },
        {
          path: 'versionUpdate',
          name: 'versionUpdate',
          component: VersionUpdate
        },
        {
          path: 'versionBack',
          name: 'versionBack',
          component: VersionBack
        },
        {
          path: 'tscIpAutoDistribute',
          name: 'tscIpAutoDistribute',
          component: TscIpAutoDistributePage
        },
        {
          path: 'appUpdate',
          name: 'appUpdate',
          component: AppUpdate
        },
        {
          path: 'versionQuery',
          name: 'versionQuery',
          component: VersionQuery
        }
      ]
    },
    {
      path: '/system',
      name: 'system',
      component: Index,
      children: [
        {
          path: 'systemManager/:id',
          name: 'systemManager',
          component: SystemManager,
        },
        {
          path: 'dataManager/:id',
          name: 'dataManager',
          component: DataManager,
        },
        {
          path: 'checkParamList',
          name: 'checkParamList',
          component: CheckParamList,
        },
        {
          path: 'configImExport',
          name: 'configImExport',
          component: ConfigExAndImport,
        },
        {
          path: 'batchInitNeCfg',
          name: 'batchInitNeCfg',
          component: BatchInitializeNeCfg,
        },
        {
          path: 'adapterManager',
          name: 'adapterManager',
          component: AdapterPkg,
        },
        {
          path: 'mailServer',
          name: 'mailServer',
          component: MailServer,
        },
        {
          path: 'historyMail',
          name: 'historyMail',
          component: HistoryMail,
        },
        {
          path: 'addressBook',
          name: 'addressBook',
          component: AddressBook,
        },
        {
          path: 'mapConfig',
          name: 'mapConfig',
          component: MapConfig,
        },
        {
          path: 'personal',
          name: 'personal',
          component: Personal,
        },
        {
          path: 'threshold',
          name: 'threshold',
          component: Threshold,
        },
        {
          path: 'alarmPresent',
          name: 'alarmPresent',
          component: AlarmPresent,
        },
        {
          path: 'systemQuery',
          name: 'systemQuery',
          component: SystemQuery,
        },
        {
          path: 'topoConfig',
          name: 'topoConfig',
          component: TopoConfig,
        },
        {
          path: 'configBackupAndRecover',
          name: 'configBackupAndRecover',
          component: ConfigBackupAndRecover,
        },
      ]
    },
    {
      path: '/security',
      name: 'security',
      component: Index,
      children: [
        {
          path: 'accountManager',
          name: 'account',
          component: AccountManager
        },
        {
          path: 'groupManager',
          name: 'group',
          component: GroupManager
        },
        {
          path: 'roleManager',
          name: 'roleManager',
          component: RoleManager
        },
        {
          path: 'strategyManager',
          name: 'strategyManager',
          component: StrategyManager
        },
        {
          path: 'accountMonitor',
          name: 'accountMonitor',
          component: AccountMonitor
        },
        {
          path: 'operateStatistic',
          name: 'operateStatistic',
          component: AccountOperateCalc
        },
        {
          path: 'logManager/:id',
          name: 'logManager',
          component: LogManager
        },
        {
          path: 'license/:id',
          name: 'license',
          component: LicenseManager
        },
        {
          path: 'client',
          name: 'client',
          component: ClientManager
        },
      ]
    },
    {
      path: '/mr',
      name: 'mr',
      component: Index,
      children: [
        {
          path: 'mrMeasureTask',
          name: 'mrMeasureTask',
          component: MrMeasureTask
        }
      ]
    },
    {
      path: '/monitor',
      name: 'monitor',
      component: Index,
      children: [
        {
          path: 'monitorSystemLog',
          name: 'monitorSystemLog',
          component: MonitorSystemLog
        },
        {
          path: 'monitorTask',
          name: 'monitorTask',
          component: MonitorTask
        },
        {
          path: 'monitorServiceProcessPage',
          name: 'monitorServiceProcessPage',
          component: MonitorServiceProcessPage
        },
        {
          path: 'realtimeMonitor',
          name: 'realtimeMonitor',
          component: RealtimeMonitor
        }
      ]
    }
  ]
});
